export default {
    // Activity types, matches ActivityFactory.php
    ACTIVITY_VERBS_ANNOUNCEMENT: 'announcement',
    ACTIVITY_VERBS_COMMENT: 'comment.designer',
    ACTIVITY_VERBS_ENTRY_COMMENT: 'comment.entry',
    ACTIVITY_VERBS_ANNOTATION: 'annotate.entry',
    ACTIVITY_VERBS_UPLOAD: 'upload.entry',
    ACTIVITY_VERBS_MESSAGE_ATTACHMENT: 'message.attachment',

    // Design statuses, matches Entry.php
    DESIGN_STATUS_TYPES_DELETED: 'deleted',
    DESIGN_STATUS_TYPES_WITHDRAWN: 'withdrawn',
    DESIGN_STATUS_TYPES_ELIMINATED: 'eliminated',
    DESIGN_STATUS_TYPES_WINNER: 'winner',
    DESIGN_STATUS_TYPES_VISIBLE: 'visible',

    // Reasons users can not enter contests
    SUBMIT_DENIED_REASON_CANNOT_VIEW: 'no-enter-cannot-view',
    SUBMIT_DENIED_REASON_OWN: 'no-enter-own',
    SUBMIT_DENIED_REASON_NOT_ACTIVATE: 'no-enter-not-activate',
    SUBMIT_DENIED_REASON_EXCLUSIVE: 'no-enter-exclusive',
    SUBMIT_DENIED_REASON_JIMDO_EXCLUSIVE: 'no-enter-jimdo-exclusive',
    SUBMIT_DENIED_REASON_NON_JIMDO_EXCLUSIVE: 'no-enter-non-jimdo-exclusive',
    SUBMIT_DENIED_REASON_LOGO_PRODUCT_PACKAGING_EXLUSIVE:
        'no-enter-logo-product-packaging-exclusive',
    SUBMIT_DENIED_REASON_INVITE: 'no-enter-invite',
    SUBMIT_DENIED_REASON_CLOSED: 'no-enter-closed',
    SUBMIT_DENIED_REASON_LOGGED_OUT: 'no-enter-logged-out',
    SUBMIT_DENIED_REASON_ELIMINATED: 'no-enter-eliminated',
    SUBMIT_DENIED_REASON_NOT_DESIGNER: 'no-enter-not-designer',
    SUBMIT_DENIED_REASON_RATE_LIMIT_EXCEEDED: 'no-enter-ratelimit-exceeded',
    SUBMIT_DENIED_REASON_VERIFICATION_REQUIRED: 'no-enter-verification-required',

    // Action keys
    VIEW_CUSTOMER_HANDOVER: 'VIEW_CUSTOMER_HANDOVER',
    VIEW_DESIGNER_HANDOVER: 'VIEW_DESIGNER_HANDOVER',
    ELIMINATE_DESIGN: 'ELIMINATE_DESIGN',
    DELETE_DESIGN: 'DELETE_DESIGN',
    DISABLED_DELETE_DESIGN: 'DISABLED_DELETE_DESIGN',
    SUBMIT_DESIGN: 'SUBMIT_DESIGN',
    DISABLED_SUBMIT_DESIGN: 'DISABLED_SUBMIT_DESIGN',
    WITHDRAW_DESIGN: 'WITHDRAW_DESIGN',
    AWARD_WINNER: 'AWARD_WINNER',
    ADD_TO_FOLIO: 'ADD_TO_FOLIO',
    REPORT_DESIGN: 'REPORT_DESIGN',

    KEYS_ENTER: 'Enter',
    KEYS_SPACE: ' ',
    KEYS_ESCAPE: 'Escape',
    KEYS_UP: 'ArrowUp',
    KEYS_DOWN: 'ArrowDown',
    KEYS_TAB: 'Tab',

    ZOOM_FLUID: 'fluid',
    ZOOM_FIT_TO_WIDTH: 'fit-to-width',
    ZOOM_FIT_TO_CONTAINER: 'fit-to-container',
    ZOOM_FIT_TO_NATIVE: 'fit-to-native',

    // Entry entity roles, duplicated in Entity/Entry.php
    DESIGN_ROLE_NONE: 'none',
    DESIGN_ROLE_GUEST: 'guest',
    DESIGN_ROLE_CUSTOMER: 'customer',
    DESIGN_ROLE_DESIGNER: 'designer',
    DESIGN_ROLE_ADMIN: 'admin',
    DESIGN_ROLE_ADMIN_CUSTOMER: 'adminCustomer',
    DESIGN_ROLE_ADMIN_DESIGNER: 'adminDesigner',

    //Modals
    AWARD_WINNER_MODAL: 'award-winner-modal',
    SELECT_FINALISTS_MODAL: 'select-finalists-modal',

    // Penalty States
    USER_BANNED: 'banned',
    USER_WARNED: 'warned',
    USER_SUSPENED: 'suspended',
};



// WEBPACK FOOTER //
// ./src/web/js/contest/data/constants.ts